import { Blocks, Box, Text, Button } from '@asktia/tia-ui'
import React, { FC, useState } from 'react'
import { usePartners } from 'src/hooks/usePartners'

export const PartnersFooter: FC = () => {
    const { data: partners, isLoading } = usePartners()

    const handleViewPerksClick = () => {
        window.open(
            'https://asktia.com/partners/',
            '_blank',
            'noopener,noreferrer'
        )
    }

    return (
        <Box
            sx={{
                backgroundColor: 'secondaryBackground',
                display: 'flex',
                padding: '68px 120px',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                position: 'relative'
            }}
        >
            <Blocks.Wave
                position="top"
                fill="secondaryBackground"
                sx={{
                    backgroundColor: 'mainBackground'
                }}
            />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--padding-16, 16px)',
                    width: '100%',
                    margin: '0 auto',
                    maxWidth: '1040px'
                }}
            >
                <Text
                    sx={{
                        color: '#282725',
                        fontFamily: 'Inferi',
                        fontSize: '32px',
                        fontStyle: 'normal',
                        fontWeight: 350,
                        lineHeight: '36px',
                        marginBottom: '16px',
                        alignSelf: 'flex-start'
                    }}
                >
                    Our Partners
                </Text>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px var(--padding-16, 16px)',
                        width: '100%',
                        flexWrap: 'wrap'
                    }}
                >
                    {isLoading ? (
                        <Text>Loading partners...</Text>
                    ) : partners && partners.length > 0 ? (
                        partners
                            .filter(partner => partner.logoUrl)
                            .map(partner => (
                                <Box
                                    key={partner.name}
                                    sx={{
                                        display: 'flex',
                                        width: '248px',
                                        padding: '16px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '10px',
                                        borderRadius: '8px',
                                        border: '1px solid #ECDCCD',
                                        background: '#FCF4E9',
                                        overflow: 'hidden',
                                        height: '64px'
                                    }}
                                >
                                    <PartnerLogo
                                        logoUrl={partner.logoUrl}
                                        partnerName={partner.name || 'Partner'}
                                    />
                                </Box>
                            ))
                    ) : (
                        <Text>No partners available</Text>
                    )}
                </Box>

                <Button
                    variant="secondaryDark"
                    onClick={handleViewPerksClick}
                    sx={{
                        display: 'flex',
                        padding: '12px 24px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        borderRadius: '8px',
                        border: '1px solid var #282725 !important',
                        cursor: 'pointer'
                    }}
                >
                    Your perks
                </Button>
            </Box>
            <Blocks.Wave
                position="bottom"
                fill="raspberry"
                sx={{
                    backgroundColor: 'secondaryBackground'
                }}
            />
        </Box>
    )
}

const PartnerLogo: FC<{ logoUrl: string; partnerName: string }> = ({
    logoUrl,
    partnerName
}) => {
    const [hasError, setHasError] = useState(false)

    if (hasError) {
        return <Text>{partnerName}</Text>
    }

    return (
        <>
            <object
                type="image/svg+xml"
                data={logoUrl}
                width="114"
                height="52"
                style={{
                    objectFit: 'contain',
                    objectPosition: 'center'
                }}
                aria-label={`${partnerName} logo`}
                onError={() => setHasError(true)}
            >
                <Text>{partnerName}</Text>
            </object>
        </>
    )
}
